import {graphql, useFragment} from 'react-relay'
import {ThreePanesLayout} from '@github-ui/three-panes-layout'
import type {RepositoryLabelsInternal$key} from './__generated__/RepositoryLabelsInternal.graphql'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {LabelList} from './LabelList'
import styles from './RepositoryLabel.module.css'
import {Button, Heading} from '@primer/react'
import {SearchBar} from './LabelSearchBar'

type RepositoryLabelsInternalProps = {
  repository: RepositoryLabelsInternal$key
}

export function RepositoryLabelsInternal({repository}: RepositoryLabelsInternalProps) {
  const data = useFragment(
    graphql`
      fragment RepositoryLabelsInternal on Repository
      @argumentDefinitions(
        first: {type: "Int!", defaultValue: 30}
        orderField: {type: "LabelOrderField", defaultValue: NAME}
        orderDirection: {type: "OrderDirection", defaultValue: DESC}
        skip: {type: "Int!"}
        query: {type: "String"}
      ) {
        ...LabelList
          @arguments(
            first: $first
            orderField: $orderField
            orderDirection: $orderDirection
            skip: $skip
            query: $query
          )
      }
    `,
    repository,
  )

  return (
    <ThreePanesLayout
      contentAs="div"
      resizeable={false}
      leftPaneWidth="small"
      middlePane={
        <div className={styles.middlePaneWrapper}>
          <div className={styles.header}>
            <Heading as="h2" className={styles.heading}>
              Labels
            </Heading>
            <Button variant="primary" size="small">
              New label
            </Button>
          </div>
          <SearchBar />
          <ErrorBoundary fallback={<div>Oops we could not load the labels</div>}>
            <LabelList repositoryRef={data} />
          </ErrorBoundary>
        </div>
      }
    />
  )
}

try{ RepositoryLabelsInternal.displayName ||= 'RepositoryLabelsInternal' } catch {}